import { Link } from "react-router-dom";
import "./Welcome.scss";

const Welcome = () => {
  return (
    <div className="welcome">
      <h1>Welcome Back!</h1>
      <div className="btns-container">
        <div className="btns-container-links">
          <Link to="https://kommunitykoin.com/" target="_blank">
            KommunityKoin
          </Link>
          <Link to="https://koinpurse.info/affiliate-program" target="_blank">
            Become an Affiliate
          </Link>
        </div>
        <Link to="https://koinpurse.info/" target="_blank">
          User Guide
        </Link>
      </div>
    </div>
  );
};

export default Welcome;
